import React from 'react'
import { Link } from 'react-router-dom'

function Team() {
  return (
    <div>
        <div className="container-fluid bg-primary py-5 mb-5 hero-header">
    <div className="container py-5">
      <div className="row justify-content-center py-5">
        <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
          <h1 className="display-3 text-white animated slideInDown">Guides</h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-center">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li
                className="breadcrumb-item text-white active"
                aria-current="page"
              >
                Travel Guides
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
      {/* Team Start */}
      <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
          <h6 className="section-title bg-white text-center text-primary px-3">
            Travel Guide
          </h6>
          <h1 className="mb-5">Meet Our Guide</h1>
        </div>
        <div className="row g-4">
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="team-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/team-1.jpg" alt="Travel Guide" />
              </div>
              <div
                className="position-relative d-flex justify-content-center"
                style={{ marginTop: "-19px" }}
              >
                <button className="btn btn-square mx-1" type="button" aria-label="Facebook">
                  <i className="fab fa-facebook-f" />
                </button>
                <button className="btn btn-square mx-1" type="button" aria-label="Twitter">
                  <i className="fab fa-twitter" />
                </button>
                <button className="btn btn-square mx-1" type="button" aria-label="Instagram">
                  <i className="fab fa-instagram" />
                </button>
              </div>
              <div className="text-center p-4">
                <h5 className="mb-0">Full Name</h5>
                <small>Designation</small>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
            <div className="team-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/team-2.jpg" alt="Travel Guide" />
              </div>
              <div
                className="position-relative d-flex justify-content-center"
                style={{ marginTop: "-19px" }}
              >
                <button className="btn btn-square mx-1" type="button" aria-label="Facebook">
                  <i className="fab fa-facebook-f" />
                </button>
                <button className="btn btn-square mx-1" type="button" aria-label="Twitter">
                  <i className="fab fa-twitter" />
                </button>
                <button className="btn btn-square mx-1" type="button" aria-label="Instagram">
                  <i className="fab fa-instagram" />
                </button>
              </div>
              <div className="text-center p-4">
                <h5 className="mb-0">Full Name</h5>
                <small>Designation</small>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="team-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/team-3.jpg" alt="Travel Guide" />
              </div>
              <div
                className="position-relative d-flex justify-content-center"
                style={{ marginTop: "-19px" }}
              >
                <button className="btn btn-square mx-1" type="button" aria-label="Facebook">
                  <i className="fab fa-facebook-f" />
                </button>
                <button className="btn btn-square mx-1" type="button" aria-label="Twitter">
                  <i className="fab fa-twitter" />
                </button>
                <button className="btn btn-square mx-1" type="button" aria-label="Instagram">
                  <i className="fab fa-instagram" />
                </button>
              </div>
              <div className="text-center p-4">
                <h5 className="mb-0">Full Name</h5>
                <small>Designation</small>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.7s">
            <div className="team-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/team-4.jpg" alt="Travel Guide" />
              </div>
              <div
                className="position-relative d-flex justify-content-center"
                style={{ marginTop: "-19px" }}
              >
                <button className="btn btn-square mx-1" type="button" aria-label="Facebook">
                  <i className="fab fa-facebook-f" />
                </button>
                <button className="btn btn-square mx-1" type="button" aria-label="Twitter">
                  <i className="fab fa-twitter" />
                </button>
                <button className="btn btn-square mx-1" type="button" aria-label="Instagram">
                  <i className="fab fa-instagram" />
                </button>
              </div>
              <div className="text-center p-4">
                <h5 className="mb-0">Full Name</h5>
                <small>Designation</small>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="team-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/team-2.jpg" alt="Travel Guide" />
              </div>
              <div
                className="position-relative d-flex justify-content-center"
                style={{ marginTop: "-19px" }}
              >
                <button className="btn btn-square mx-1" type="button" aria-label="Facebook">
                  <i className="fab fa-facebook-f" />
                </button>
                <button className="btn btn-square mx-1" type="button" aria-label="Twitter">
                  <i className="fab fa-twitter" />
                </button>
                <button className="btn btn-square mx-1" type="button" aria-label="Instagram">
                  <i className="fab fa-instagram" />
                </button>
              </div>
              <div className="text-center p-4">
                <h5 className="mb-0">Full Name</h5>
                <small>Designation</small>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
            <div className="team-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/team-3.jpg" alt="Travel Guide" />
              </div>
              <div
                className="position-relative d-flex justify-content-center"
                style={{ marginTop: "-19px" }}
              >
                <button className="btn btn-square mx-1" type="button" aria-label="Facebook">
                  <i className="fab fa-facebook-f" />
                </button>
                <button className="btn btn-square mx-1" type="button" aria-label="Twitter">
                  <i className="fab fa-twitter" />
                </button>
                <button className="btn btn-square mx-1" type="button" aria-label="Instagram">
                  <i className="fab fa-instagram" />
                </button>
              </div>
              <div className="text-center p-4">
                <h5 className="mb-0">Full Name</h5>
                <small>Designation</small>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="team-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/team-4.jpg" alt="Travel Guide" />
              </div>
              <div
                className="position-relative d-flex justify-content-center"
                style={{ marginTop: "-19px" }}
              >
                <button className="btn btn-square mx-1" type="button" aria-label="Facebook">
                  <i className="fab fa-facebook-f" />
                </button>
                <button className="btn btn-square mx-1" type="button" aria-label="Twitter">
                  <i className="fab fa-twitter" />
                </button>
                <button className="btn btn-square mx-1" type="button" aria-label="Instagram">
                  <i className="fab fa-instagram" />
                </button>
              </div>
              <div className="text-center p-4">
                <h5 className="mb-0">Full Name</h5>
                <small>Designation</small>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.7s">
            <div className="team-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/team-1.jpg" alt="Travel Guide" />
              </div>
              <div
                className="position-relative d-flex justify-content-center"
                style={{ marginTop: "-19px" }}
              >
                <button className="btn btn-square mx-1" type="button" aria-label="Facebook">
                  <i className="fab fa-facebook-f" />
                </button>
                <button className="btn btn-square mx-1" type="button" aria-label="Twitter">
                  <i className="fab fa-twitter" />
                </button>
                <button className="btn btn-square mx-1" type="button" aria-label="Instagram">
                  <i className="fab fa-instagram" />
                </button>
              </div>
              <div className="text-center p-4">
                <h5 className="mb-0">Full Name</h5>
                <small>Designation</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* Team End */}
    </div>
  )
}

export default Team
